// react
import * as React from 'react';
import { Field, InjectedFormProps, reduxForm, WrappedFieldProps } from 'redux-form';

// material-ui
import Grid from '@material-ui/core/Grid/Grid';
import Button from '@material-ui/core/Button/Button';
import TextField from '@material-ui/core/TextField/TextField';

// project files
import * as styles from './ContactForm.css';
import { FormProps } from '../../shared/Forms/FormSection/FormSection';
import { required } from '../../shared/Forms/validations';


const ContactForm = ({ handleSubmit, submitting }: InjectedFormProps) => (
  <form onSubmit={handleSubmit} className={styles.contactForm}>
    <Grid container alignItems="center" justify="center">
      <Grid item xs={12} container direction="column">
        <Field
          disabled
          name="name"
          type="text"
          component={DisabledTextField}
          label="Name"
          validate={required}
        />
        <Field
          name="email"
          type="text"
          component={DisabledTextField}
          label="Email"
          validate={required}
        />
        <Field
          name="message"
          type="text"
          component={TextAreaField}
          label="Message"
          validate={required}
        />
        <Grid container justify="flex-end">
          <Button
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            disabled={submitting}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Grid>
  </form>
);

const TextAreaField = (props: WrappedFieldProps & FormProps) => (
  <Grid container justify="center">
    <TextField
      id="outlined-multiline-flexible"
      label="How can we help you?"
      multiline
      rows="10"
      fullWidth
      {...props.input}
      margin="normal"
      variant="outlined"
    />
    {props.meta.touched && props.meta.error && <span>{props.meta.error}</span>}
  </Grid>
);

const DisabledTextField = (props: WrappedFieldProps & FormProps) => (
  <TextField
    {...props.input}
    disabled
    id="outlined-full-width"
    label={props.label}
    margin="normal"
    fullWidth
    variant="outlined"
  />
);

export default reduxForm({
  form: 'contactForm',
  enableReinitialize: true
})(ContactForm);
